import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { FinanceStatisticsDto } from '../models/finance-statistics-dto';
import { ContributionDto, SearchContributionDto } from '../models/contribution-dto';
import { ExportType } from '../../../shared/models/search-base';

@Injectable({
  providedIn: 'root'
})
export class FinanceService {
  private baseUrl = 'Finance';
  
  constructor(private httpCommonService: HttpCommonService) {}

  getFinanceStatistics(): Observable<ApiResponse<FinanceStatisticsDto>> {
    return this.httpCommonService.get<ApiResponse<FinanceStatisticsDto>>({ 
      url: `${this.baseUrl}/GetStatistics` 
    });
  }

  getFinanceStatisticsByYear(year: number): Observable<ApiResponse<FinanceStatisticsDto>> {
    return this.httpCommonService.get<ApiResponse<FinanceStatisticsDto>>({
      url: `${this.baseUrl}/GetStatistics?year=${year}`
    });
  }

  getContributions(searchDto: SearchContributionDto): Observable<ApiResponse<SearchContributionDto>> {
    return this.httpCommonService.post<ApiResponse<SearchContributionDto>>({
      url: `${this.baseUrl}/GetContributions`,
      body: searchDto
    });
  }

  exportContributions(searchDto: SearchContributionDto): Observable<Blob> {
    return this.httpCommonService.post<Blob>({
      url: `${this.baseUrl}/Export`,
      body: searchDto,
      responseType: 'blob'
    });
  }
}
